export default {
    breadcrumbs: {
        company: 'Company',
        my_company: 'My company',
        preview: 'Company profile',
    },
    tabs: {
        profile: 'Profile',
        personal_details: 'Settings',
        settings: 'Settings',
        gallery: 'Gallery',
        locations: 'Locations',
        services: 'Services',
        users: 'Users',
        inactivity: 'Inactivity',
        discount: 'Discounts',
        invoices: 'Invoices',
        clients: 'Clients',
        client: 'Client',
        chart: 'Statistics',
        reminder: 'Reminder',
        performers: 'Empoloyees',
    },
    offer_tabs: {
        active: 'Active ({number})',
        renewal: 'For reneewal ({number})',
        expired: 'Expired ({number})',
    },
    buttons: {
        upload_company_logo: 'Upload company logo',
        change_cover_photo: 'Change photo',
        add_inactivity: 'Add inactivity',
        add_discount: 'Add discount',
    },
    no_added_inactivity: 'You have no inactivity added!',
    no_added_invoice: 'You have no invoices!',
    delete_company: 'Delete company',
    reactivate_company: 'Reactivate company',
    successfully_deleted: 'Company successfully deleted',
    successfully_reactivated: 'Company successfully reactivated',
    delete_company_modal_heading: 'Are you sure you want to deactivate company?',
    activate_company_modal_heading: 'Are you sure you want to reactivate company again?',
    no_added_reminders: 'You have no added reminders!',
    outstandingsAmountCompanies: 'Several of your companies have outstanding debts. Please settle them.',
    outstandingsAmountCompany: 'You have an outstanding balance of {n} {m} at {c}. Please settle it soon.',
    search_performer: 'Search performer',

    errors: {
        not_found: 'Company is not found',
        already_active: 'Company is already active',
        is_in_debt: 'Please pay your debt',
    },
}
